<template>
    <div class="customer-detail-modal">
    <el-row>
        <el-col  :span="23" :offset='1' >
            <el-form :model="detail.data" ref="userEdit" label-width="300px" label-position="left" :rules="rulesUserInfo">
                <el-form-item
                    prop="email"
                    label="อีเมล์ลูกค้า (สำหรับล๊อกอินเข้าระบบ)"
                    :rules="[
                    { required: true, message: 'กรุณากรอกอีเมล์ลูกค้า', trigger: 'blur' },
                    { type: 'email', message: 'กรุณาตรวจสอบรูปแบบอีเมล์ลูกค้า', trigger: ['blur', 'change'] }]">

                    <div style='display: flex'>
                        <el-input v-model="detail.data.email" :disabled="flagEditMail"></el-input>
                        <el-button type="danger" style='margin-left: 10px' icon="el-icon-edit" @click="flagEditMail = false"></el-button>
                    </div>

                </el-form-item>
                <el-form-item label="Quotation Date" class="labelForm">
                    <el-input v-model="quotationDate" disabled></el-input>
                </el-form-item>
                <el-form-item
                    prop="userCode"
                    label="รหัสลูกค้า"
                    :rules="[{ required: true, message: 'กรุณากรอกรหัสลูกค้า', trigger: 'blur' }]">
                    <el-row>
                        <el-col :md='16' :lg='12'>
                            <el-input v-model="detail.data.userCode" ></el-input>
                        </el-col>
                        <el-col :md='8' :lg='12'>
                            <el-switch
                                v-model="detail.data.isActivate"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                active-text="Activate"
                                inactive-text="Deactivate">
                            </el-switch>
                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item label="ชื่อ" prop="firstName" :rules="[{ required: true, message: 'กรุณากรอกชื่อลูกค้า', trigger: 'blur' }]">
                    <el-input v-model="detail.data.firstName"></el-input>
                </el-form-item>

                <el-form-item label="นามสกุล" prop="lastName" :rules="[{ required: true, message: 'กรุณากรอกชื่อลูกค้า', trigger: 'blur' }]">
                    <el-input v-model="detail.data.lastName"></el-input>
                </el-form-item>

                <el-form-item label="ที่อยู่ผู้ใช้งาน" prop="address" :rules="[{ required: true, message: 'กรุณากรอกที่อยู่ผู้ใช้งาน', trigger: 'blur' }]">
                    <el-input v-model="detail.data.address"></el-input>
                </el-form-item>
                <address-system
                            ref="formAddress"
                            :address="address"
                            :isSubmitForm="isSubmitForm"
                            :isCancel="isCancel"
                            @updated:address="updateAddress($event)"
                            @onCancel="(value)=>$emit('onCancel', value)" />
                <!-- <zipcode-system
                    ref="zipcode-system-component"
                    class="zipcode-system-customer"
                    :province="address.province"
                    :district="address.district"
                    :envelopment="$store.get('envSystem/mode')"
                    :sub-district="address.subDistrict"
                    :zipcode="address.zipcode"
                    @onCompleteAddress="updateAddress($event)"
                /> -->
                <el-form-item label="เบอร์โทรติดต่อเข้ารับสินค้า" prop="phoneNumber" class="labelForm" :rules="[{ required: true, message: 'กรุณากรอกเบอร์โทรติดต่อ', trigger: 'blur' }]">
                    <el-input class="input-phone-number"  maxlength="10" v-model="detail.data.phoneNumber" @keypress.native="integerValueChecker($event, detail.data.phoneNumber)"> </el-input>
                </el-form-item>

                <el-form-item label="Status" label-width="300px">
                     <el-row type='flex' justify='space-between'>
                         <el-radio-group v-model="detail.data.userStatus">
                             <el-radio-button v-for="item in CustomerStatusAccount" :key="item.id" :label="item.id">{{item.label}}</el-radio-button>
                         </el-radio-group>
                         <el-form-item label="Price Type" label-width="85px" >
                             <el-radio-group v-model="detail.data.deliveryCostType">
                                 <el-radio-button v-for="item in PriceType" :key="item.id" :label="item.id">{{item.label}}</el-radio-button>
                             </el-radio-group>
                         </el-form-item>
                     </el-row>
                </el-form-item>

                <el-form-item label="Field Sale">
                            <el-select
                                v-model="detail.data.saleCode"
                                placeholder="Field Sale"
                                @click.native="remoteMethodSaleCode"
                                :loading="loadingSaleCode"

                                >
                                    <el-option-group
                                        v-for="group in saleCodeList"
                                        :key="group.name"
                                        :label="group.name"
                                        >
                                        <el-option
                                            v-for="item in group.saleCodes"
                                            :key="item.code"
                                            :label="item.code"
                                            :value="item.code" >
                                        </el-option>
                                    </el-option-group>
                            </el-select>
                        </el-form-item>
                <el-form-item label="Secondary Sale">
                    <el-select
                            v-model="detail.data.saleCodeSec"
                            placeholder="Secondary Sale"
                            @click.native="remoteMethodSaleCodeSecondary"
                            :loading="loadingSaleCodeSecondary"
                            :disabled="selectSaleCode"
                            >
                                <el-option-group
                                    v-for="group in saleCodeSecondaryList"
                                    :key="group.name"
                                    :label="group.name"
                                    >
                                    <el-option
                                        v-for="item in group.saleCodes"
                                        :key="item.code"
                                        :label="item.code"
                                        :value="item.code">
                                    </el-option>
                                </el-option-group>
                        </el-select>
                </el-form-item>
                <!-- Customer Relation = Customer Retention-->
                <el-form-item label="Customer Relation" prop="customerRetention">
                    <el-input maxlength="100" v-model="detail.data.customerRetention" > </el-input>
                </el-form-item>
                <el-form-item label="Customer Support" prop="customerSupport">
                    <el-input maxlength="100" v-model="detail.data.customerSupport" > </el-input>
                </el-form-item>
                <el-form-item label="Approve" class="labelForm">
                        <div  style='display: flex'>
                            <el-input  maxlength="100" v-model="approved" type='string' readonly style='overflow-x: auto'></el-input>
                            <el-switch
                                v-if="statusBlock"
                                v-model="detail.data.isBlock"
                                active-color="#ff4949"
                                inactive-color="#13ce66"
                                active-text="Block"
                                inactive-text="Normal"
                                style='margin-left: 10px;align-items:center;'>
                            </el-switch>
                            <el-button type="danger" @click="changeStatusBlockUser" style='margin-left: 10px' icon="el-icon-lock" v-else></el-button>
                            <el-button type="warning" @click="onShowHistoryEdit">ประวัติการแก้ไข</el-button>
                        </div>
                </el-form-item>
                <el-form-item label="Tags" >
                    <div class='custom-box'>
                        <span v-if='detail.operationTag.length>0'>
                            <el-tag  class="online-cancel-tag text-md-left" v-for="(tagData,index) in detail.operationTag" :key="index">{{tagData}}</el-tag>
                        </span>
                        <span v-else>
                           -
                        </span>
                    </div>
                </el-form-item>
                <el-form-item label="Zoho Id" prop="zohoInternalId" class="labelForm">
                    <el-input v-model="detail.data.zohoInternalId"></el-input>
                </el-form-item>
            </el-form>
        </el-col>
         <dialog-history-edit :detail.sync="dialogHistory"/>
    </el-row>
    </div>
</template>
<script>
import fgApi from '@/services/fillgoods'
// import helperProvince from '@/components/helper/BaseProvinceSelect'
// import ZipcodeSystem from '@bit/fillgoodscompany.fg-component.zipcode-system'
import AddressSystem from '@/components/address/AddressSystem.vue'
import DialogHistoryEdit from '@/components/Customer/DialogHistoryEdit'

export default {
    name: 'dialogCustomerDetail',
    props: {
        detail: {
            type: Object
        },
        provinceArray: {
            type: Array,
            default: null
        },
        geoHierarchyData: {
            type: Object,
            default: null
        },
        seller: {
            type: Array
        },
        log: {
            type: Object,
            default: null
        },
        isSubmitForm: {
            type: Boolean,
            deault: false
        },
        isCancel: {
            type: Boolean,
            deault: false
        }
    },
    components: {
        // ZipcodeSystem,
        'address-system': AddressSystem,
        DialogHistoryEdit
    },
    data () {
        return {
            flagEditMail: true,
            innerVisible: false,
            listProvider: [],
            tag: {
                provi: 'province',
                distr: 'district',
                subDist: 'subDistrict'
            },
            rulesUserInfo: {
                province: [
                    { required: true, message: 'กรุณาเลือกจังหวัด', trigger: 'change' }
                ],
                district: [
                    { required: true, message: 'กรุณาเลือกอำเภอ', trigger: 'change' }
                ],
                subDistrict: [
                    { required: true, message: 'กรุณาเลือกตำบล', trigger: 'change' }
                ]
            },
            dialogHistory: {
                dialog: false,
                userId: null,
                userEmail: null,
                type: null
            },
            loadingSaleCode: false,
            loadingSaleCodeSecondary: false,
            saleCodeList: [],
            saleCodeSecondaryList: [],
            quotationDate: '-',
            statusBlock: false,
            address: {
                province: '',
                district: '',
                subDistrict: '',
                zipcode: '' }
        }
    },
    computed: {
        checkBtnShow () {
            if (this.detail.hasOwnProperty('is_customer_regis')) {
                return false
            }
            return true
        },
        provinceName () {
            return this.detail.data.province || ''
        },
        selectSaleCode () {
            return !this.detail.data.saleCode
        },
        approved () {
            const approvedBy = this.detail.data.approvedBy ? this.detail.data.approvedBy : '-'
            const approvedAt = this.detail.data.approvedAt ? this.$dayjs(this.detail.data.approvedAt).format('YYYY-MM-DD HH:mm:ss') : ''
            return approvedBy + ' ' + approvedAt
        }
    },
    watch: {
        'detail.dialog': {
            immediate: true,
            handler (val) {
                if (val) {
                    this.address.province = this.detail.data.province
                    this.address.district = this.detail.data.district
                    this.address.subDistrict = this.detail.data.subDistrict
                    this.address.zipcode = this.detail.data.zipcode
                } else {
                    this.flagEditMail = true
                    this.address.province = ''
                    this.address.district = ''
                    this.address.subDistrict = ''
                    this.address.zipcode = ''
                    // if (this.$refs['zipcode-system-component']) { this.$refs['zipcode-system-component'].$v.$reset() }
                }
            }
        },
        'detail.data' (item) {
            this.address.province = item.province
            this.address.district = item.district
            this.address.subDistrict = item.subDistrict
            this.address.zipcode = item.zipcode
        }
    },
    methods: {
        async remoteMethodSaleCode (query) {
            this.loadingSaleCode = true
            this.saleCodeList = []
            try {
                let res = await fgApi.seller.getALlSaleCode()
                if (res.success) {
                    this.saleCodeList = res.data
                }
            } catch (error) {
                console.error(error)
            }
            this.loadingSaleCode = false
        },
        async remoteMethodSaleCodeSecondary (query) {
            this.loadingSaleCodeSecondary = true
            this.saleCodeSecondaryList = []
            const param = {
                mode: 2,
                exceptSaleCode: [this.detail.data.saleCode]
            }
            try {
                let res = await fgApi.seller.getALlSaleCode(param)
                if (res.success) {
                    this.saleCodeSecondaryList = res.data
                } else {
                    this.$message.error('sale CodeSecondary not success')
                }
            } catch (error) {
                console.error(error)
            }
            this.loadingSaleCodeSecondary = false
        },
        onShowHistoryEdit () {
            this.dialogHistory.dialog = !this.dialogHistory.dialog
            this.dialogHistory.userId = this.detail.data.userId
            this.dialogHistory.userEmail = this.detail.data.email
            this.dialogHistory.type = 'customerDetail'
        },
        changeStatusBlockUser (val) {
            const validatePassword = (input) => {
                if (input === 'Aa666666!') {
                    return true
                }
                return 'รหัสไม่ถูกต้อง'
            }
            this.$prompt('', 'ยืนยันรหัส', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                inputType: 'password',
                inputValidator: validatePassword
            }).then(({ value }) => {
                this.statusBlock = true
            }).catch(() => {})
        },
        updateAddress (address) {
            this.detail.data.province = address.province
            this.detail.data.district = address.district
            this.detail.data.subDistrict = address.subDistrict
            this.detail.data.zipcode = address.zipcode
            // this.detail.data.province = address.name.province
            // this.detail.data.district = address.name.district
            // this.detail.data.subDistrict = address.name.subDistrict
            // this.detail.data.zipcode = address.name.zipcode
        },
        integerValueChecker (event, target) {
            let isAllow = /[0-9]/.test(String.fromCharCode(event.which))
            if (isAllow) {
                target = target + event.key
                isAllow = /^\d+$/.test(target)
            }
            if (!isAllow) {
                event.preventDefault()
            }
        }

    }
}
</script>
<style lang="scss">
.customer-detail-modal{
    max-width: 1024px;
.labelForm {
    label {
        padding: unset !important;
    }
}
.dailogCustomerDetail {
    .el-dialog__header {
        background-color: teal;
        color: white;
        button {
            font-size: large;
            i {
                color: #ffffff;
                &:hover {
                    color: white;
                }
            }
        }
    }
}
.my-autocomplete {
    li {
      line-height: normal;
      padding: 7px;

      .shipperCode {
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .link {
        font-size: 12px;
        color: #b4b4b4;
      }
    }
  }
  .online-cancel-tag{
      margin:0 3px;
      border: #DCDFE6;
  }
  .el-date-editor .el-range-separator {
      width: 10%;
  }
  .zipcode-system-customer{
      .autocomplete.-stack{
          padding: 0px 0 24px 0px !important;
      }
      padding-bottom: 12px;
      .input{
          width: 100% !important;
        }
        //   ._bordererror{
        //       border: 1px solid #F56C6C !important;
        //   }
          .field{
            color: #606266;
            display: flex;
            align-items: center;
            .label{
                min-width: 300px!important;
                text-align: start;
            }
            .input{
                .field{
                    border: 1px solid #DCDFE6;
                    // padding-left: 15px;
                }
            }
          }
        //   .field:focus{
        //     border: 1px solid #26a69a !important;
        //     outline:none;
        //   }
        //   .field:disabled{
        //     background-color: #F5F7FA !important;
        //   }
        //   .errormessage{
        //       color: #F56C6C !important;
        //   }
          .icon{
            font-size: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

  }
}
</style>
<style scoped>
    .btn-customer-dialog{
        text-align: right;
        padding: 30px 0;
    }
    .el-input,.el-select {
        width: 100%;
    }
    .custom-box{
        border: #DCDFE6 1px solid;min-width: 30px;width: auto;border-radius: 4px;
    }
</style>
